import { Box, styled, Typography } from "@mui/material";

export const StyledWrapper = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));
export const StyledBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  padding: "20px",
  borderRadius: theme.borderRadius.radius.wallet,
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  backgroundColor: theme.palette.custom.searchBg,
  width: "50%",
}));
export const StyledTypography = styled(Typography)(({ size, theme }) => ({
  fontSize: size
    ? theme.typography.regular.fontSize
    : theme.typography.notFoundLarge.fontSize,
  fontWeight: !size && theme.typography.fontWeight.bold,

  [theme.breakpoints.down("sm")]: {
    fontSize: size
      ? theme.typography.tiny.fontSize
      : theme.typography?.["5xl"].fontSize,
  },
}));
